import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  questionnaires: [],
  currentQuestionnaire: null,
  isLoading: false,
  error: null,
};

const questionnaireSlice = createSlice({
  name: 'questionnaire',
  initialState,
  reducers: {
    setQuestionnaires: (state, action) => {
      state.questionnaires = action.payload;
    },
    setCurrentQuestionnaire: (state, action) => {
      state.currentQuestionnaire = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setQuestionnaires,
  setCurrentQuestionnaire,
  setLoading,
  setError,
  clearError,
} = questionnaireSlice.actions;

export default questionnaireSlice.reducer;
